module.exports = __webpack_public_path__ + "static/media/miurac.c338736d.jpg";